import React from "react";

function WifiOff() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <g clipPath="url(#clip0_149_121)">
        <path
          stroke="#FF6262"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
          d="M.583.583l12.834 12.834M9.753 6.452a6.38 6.38 0 011.33.869m-8.166 0a6.382 6.382 0 013.015-1.394m.315-2.981a9.333 9.333 0 016.925 2.304m-12.344 0A9.28 9.28 0 013.57 3.57m1.406 5.827a3.5 3.5 0 014.054 0M7 11.667h.006"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_149_121">
          <path fill="#fff" d="M0 0H14V14H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default WifiOff;
